module.exports = __webpack_public_path__ + "img/támogatások.6e04d086.svg";